import React from 'react';

const Home: React.FC = () => {
  return (
    <div className="page home">
      <div className="container home-grid">
        <div className="profile-section">
          <img src="/images/PawelPiwosz.png" alt="Pawel Piwosz" className="profile-image" />
          <h1>Pawel Piwosz</h1>
          <p className="title"> ♥ 💙 ♥ Developer Advocate ♥ 💙 ♥</p>
          <p className="head_subtitle">DevOps Manager, Coach & Cloud Architect</p>
          
          <div className="badges">
            <div className="floating-badges">
              <div className="floating-badge" data-float-delay="0">
                <div className="badge-content">
                  <div className="badge-icon docker-color">
                    <i className="fab fa-docker"></i>
                  </div>
                  <div className="badge-info">
                    <span className="badge-title">Docker Captain</span>
                    <span className="badge-subtitle">Container Expert</span>
                  </div>
                </div>
              </div>
              
              <div className="floating-badge" data-float-delay="400">
                <div className="badge-content">
                  <div className="badge-icon cd-color">
                    <i className="fas fa-rocket"></i>
                  </div>
                  <div className="badge-info">
                    <span className="badge-title">CD.Foundation Ambassador</span>
                    <span className="badge-subtitle">CI/CD Expert</span>
                  </div>
                </div>
              </div>
              
              <div className="floating-badge" data-float-delay="600">
                <div className="badge-content">
                  <div className="badge-icon devops-color">
                    <i className="fas fa-infinity"></i>
                  </div>
                  <div className="badge-info">
                    <span className="badge-title">DevOps Institute Ambassador</span>
                    <span className="badge-subtitle">DevOps Leader</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="content-section">
          <div className="intro">
            <h2>Engineer • Leader • Mentor • Speaker</h2>
            <p className="highlight">Almost 30 years of experience in IT world, specializing in high-load systems and cloud architecture.</p>
          </div>

          <div className="background">
            <p>My journey started as SysOps, evolved through DevOps, leading to my current role as a DevOps Coach and ...well... influencer. Along the way, I've gained experience as a Scrum Master, Delivery Manager, Solution Architect and Developer Advocate.</p>
          </div>

          <div className="current">
            <p>Today I wait for new journey which will start soon, so, stay tuned!</p>
          </div>

          <div className="community">
            <p>Active community member:</p>
            <ul>
              <li>Host of two podcasts and two YouTube channels</li>
              <li>Organizer of AWS Community Day, DevOps Days (Krakow & Warsaw) and Kubernetes Community Day</li>
              <li>TADA conference program committee member</li>
              <li>Cloud Native Krakow Chapter co-organizer</li>
              <li>Mentor in Tech Leaders program</li>
              <li>Guest lecturer at UWSB Merito</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;